<div class="overlay">
  <div class="loader-block">
    <div>
      <tui-loader class="loader" [inheritColor]="true" />
    </div>
    <div class="tui-space_top-2">{{ textEvent | translate }}...</div>
    @if (isVisibleButton) {
      <button
        class="tui-space_top-2"
        tuiButton
        type="button"
        appearance="outline"
        (click)="cancel()"
      >
        {{ 'Cancel' | translate }}
      </button>
    }
  </div>
</div>
